import type * as api from '@gitbook/api-client';

import { hasChangeCounts } from '../Diff';

/**
 * Whether a change request holds content changes, from the counts the API computes for it.
 *
 * Until those are computed, a revision that moved past the one the change request started from
 * stands in for them.
 */
export function hasChangeRequestContentChanges(
    changeRequest: Pick<api.ChangeRequest, 'revision' | 'revisionInitial' | 'changeCounts'>
): boolean {
    const { changeCounts } = changeRequest;
    if (!changeCounts) {
        return changeRequest.revision !== changeRequest.revisionInitial;
    }

    return [changeCounts.pages, changeCounts.library].some(hasChangeCounts);
}
